//src/components/layout/NavBar.jsx

import { Link } from 'react-router-dom';
import Logo from '../Logo';

const NavBar = ({ isAuthenticated }) => {
  return (
    <nav style={{
      padding: '1rem',
      backgroundColor: '#f8f9fa',
      marginBottom: '2rem',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        {/* Logo/Brand Section */}
        <Link to="/" style={{ 
          textDecoration: 'none',
          display: 'flex',
          alignItems: 'center'
        }}>
          <Logo size="medium" showText={false} />
        </Link>

        {/* Navigation Links */}
        <ul style={{
          listStyle: 'none',
          margin: 0,
          padding: 0,
          display: 'flex',
          gap: '2rem',
          alignItems: 'center'
        }}>
          <li>
            <Link to="/latest" style={{ textDecoration: 'none', color: '#333' }}>Latest</Link>
          </li>
          <li>
            <Link to="/ask" style={{ textDecoration: 'none', color: '#333' }}>Ask</Link>
          </li>
          {isAuthenticated && (
            <li>
              <Link to="/private" style={{ textDecoration: 'none', color: '#333' }}>Private</Link>
            </li>
          )}
          <li>
            <Link to="/about" style={{ textDecoration: 'none', color: '#333' }}>About</Link>
          </li>
          <li>
            <Link to="/contact" style={{ textDecoration: 'none', color: '#333' }}>Contact</Link>
          </li>
          <li>
            <Link to="/resources" style={{ textDecoration: 'none', color: '#333' }}>Resources</Link>  
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default NavBar;

/*
import { Link } from 'react-router-dom';

const NavBar = ({ isAuthenticated }) => {
  return (
    <nav style={{
      padding: '1rem',
      backgroundColor: '#f8f9fa',
      marginBottom: '2rem',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }}>
      <ul style={{
        listStyle: 'none',
        margin: 0,
        padding: 0,
        display: 'flex',
        gap: '2rem'
      }}>
        <li>
          <Link to="/" style={{ textDecoration: 'none', color: '#333' }}>Home</Link>
        </li>
        <li>
          <Link to="/latest" style={{ textDecoration: 'none', color: '#333' }}>Latest</Link>
        </li>
        <li>
          <Link to="/ask" style={{ textDecoration: 'none', color: '#333' }}>Ask</Link>
        </li>
        {isAuthenticated && (
          <li>
            <Link to="/private" style={{ textDecoration: 'none', color: '#333' }}>Private</Link>
          </li>
        )}
        <li>
          <Link to="/about" style={{ textDecoration: 'none', color: '#333' }}>About</Link>
        </li>
        <li>
          <Link to="/contact" style={{ textDecoration: 'none', color: '#333' }}>Contact</Link>
        </li>
        <li>
          <Link to="/resources" style={{ textDecoration: 'none', color: '#333' }}>Resources</Link>  
        </li>
      </ul>
    </nav>
  );
};

export default NavBar; 
*/